export default function PageVisie() {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Visie / Missie</h2>      
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
        <img 
          src="/images\2025.05\Visie_ZorgInTeam-origineel-transparant-cropped-h50.png"
          alt="Artsenpraktijk Waarloos"
        />
        <h3 style={{ marginBottom: '0px'}}>Zorg in team</h3>
      </div>
      <p>
        We kiezen ervoor om als groepspraktijk te werken in een hecht teamverband.
        We geloven dat dit positief is voor zowel de patiënt als de arts. Als patiënt kan je bij ons alle vijf terecht 
        voor al je problemen en ben je niet gebonden aan één vaste arts. Als er een voorkeur is voor een specifieke arts, 
        proberen we daarmee wel rekening te houden. Als arts is er door het werken in teamverband ruimte voor overleg én 
        voor een balans tussen werken en ons leven daarbuiten.
      </p>
      <h3 style={{ marginBottom: '5px'}}>Bewust klein team</h3>
      <p>
        We kiezen ervoor om bewust een relatief klein team te blijven van 4 huisartsen, 1 HAIO en een secretaresse.
        Zo willen we de persoonlijke band met elkaar én met onze patiënten verzekeren. We willen het huiselijke van 
        de huisartsenpraktijk vasthouden en niet evolueren naar een soort bedrijf.
        Wel werken we graag samen met verpleegkundigen, psychotherapeuten en andere paramedici aangezien dit een meerwaarde is voor de patiëntenzorg.
      </p>
       <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
        <img 
          src="/images\2025.05\Visie_EvidenceBased-origineel-transparant-cropped-h50.png"
          alt="Artsenpraktijk Waarloos"
        />
        <h3 style={{ marginBottom: '0'}}>Evidence based</h3>
      </div>
      <p>
        We vinden het belangrijk om ons geregeld bij te scholen en om ons steeds te baseren om de meest recente wetenschappelijke kennis. 
        We proberen daarbij wel steeds rekening te houden met de individuele situatie van elke patiënt.
      </p>
      <h3 style={{ marginBottom: '5px'}}>Laagdrempelig</h3>
      <p>
        We willen laagdrempelig voor iedereen uit Waarloos beschikbaar zijn. We zijn er voor alle patiënten en voor 
        een heel brede problematiek. We hebben oog voor alle onderdelen van de gezondheid, zo ook mentale gezondheid 
        en bijvoorbeeld palliatieve zorgen.        
      </p>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
        <img 
          src="/images\2025.05\Visie_Opleiding-origineel-transparant-cropped-h50.png"
          alt="Artsenpraktijk Waarloos"
        />
        <h3 style={{ marginBottom: '0'}}>Opleiding</h3>
      </div>
      <p>
        We zijn een opleidingspraktijk. We vinden het opleiden van jonge (huis)artsen een grote meerwaarde voor zowel 
        hen als voor onszelf. Dat betekent dat er steeds een huisarts in opleiding aanwezig is in de praktijk en dat 
        er af en toe stagiairs zullen langskomen.
      </p>
    </div>
  );
}